/* eslint-disable max-len */
import React,{useContext,useEffect,useState} from 'react'
import AdvancedSearchInputBox from '../../../../components/AdvancedSearchInput/AdvancedSearchInputBox';
import { useSelector,useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { resetAlertNotificationSearch,setAlertNotificationSearch } from '../../../../redux/alerAndNotificationSearchSlice';
import Dropdown from '../../../../components/Dropdown';
import GlobalContext from '../../../../components/Context/GloablContext';
import DateInput from '../../../../components/DateField';

export default function AlertNotificationSearchbar({handleOnSubmit,emptyField,setEmptyField,providerAlertsSearch,monitorConditionTemplateSearch}) {
    const AlertNotificationSearch = useSelector(state => state.AlertNotificationSearchData);
    const {isSearchOpen,setIsSearchOpen,isSideBar,setIsSideBar} = useContext(GlobalContext);
    const [searchParams,setSearchParams]=useSearchParams()
    const dispatch = useDispatch()
    const sidebarPrvState = useSelector(state => state?.systemConfigData?.sidebarPrvState)
    const searchApplied = useSelector((state) => state.AlertNotificationSearchData.setAlertNotificationSearchApplied);

    // handleOnChangeUserDetails function
    const handleOnChangeUserDetails = (id, value) => {
        let updatedValue = value;
        // Apply field-specific validation rules
        switch (id) {
        case 'age':
            // Allow only numeric input for the "age" field
            updatedValue = updatedValue.replace(/\D/g, ''); // Removes any non-numeric characters
            break;
        case 'alert_title':
            // Allow only numbers and the '*' character for 'alert_title'
            updatedValue = updatedValue.replace(/[^0-9*]/g, ''); // Removes invalid characters
            break;
        default:
            // No validation for other fields
            break;
        }
    
        // Ensure inverse field is cleared if the value is empty
        const updatedState = { ...AlertNotificationSearch, [id]: updatedValue };
        if (updatedValue === '' && updatedState[`${id}_inverse`] === 'true') {
            updatedState[`${id}_inverse`] = '';
        }
    
        // Only update state if there is a change
        if (AlertNotificationSearch[id] !== updatedValue || AlertNotificationSearch[`${id}_inverse`] !== updatedState[`${id}_inverse`]) {
            setAlertNotificationSearch(updatedState);
            dispatch(setAlertNotificationSearch(updatedState));
        }
    };
    
    //handleSelect checkbox functions
    // Utility function to handle inverse logic
    const updateInverseLogic = (updatedState, field) => {
        if (Array.isArray(updatedState[field]) && updatedState[field].length === 0) {
        // Clear the inverse field if the array is empty
            updatedState[`${field}_inverse`] = '';
        }
        return updatedState;
    };

    // Refactored handleCheckboxChange function
    const handleCheckboxChange = (e, field) => {
        const { checked } = e.target;
        let updatedState = { ...AlertNotificationSearch };

        if (field === 'High' || field === 'Medium') {
        // Update the alert_severity array
            const updatedalert_severity = checked
                ? [...(AlertNotificationSearch.alert_severity || []), field]
                : (AlertNotificationSearch.alert_severity || []).filter((alert_severity) => alert_severity !== field);

            updatedState.alert_severity = updatedalert_severity;

            // Use the generic inverse logic handler
            updatedState = updateInverseLogic(updatedState, 'alert_severity');
        } else {
        // Handle other fields as boolean values
            updatedState[field] = checked ? 'true' : '';

            // Apply inverse logic for other fields if necessary
            if (!checked && updatedState[`${field}_inverse`] === 'true') {
                updatedState[`${field}_inverse`] = '';
            }
        }

        // Dispatch the updated state
        dispatch(setAlertNotificationSearch(updatedState));
    };

    const dateformatSysconfig = useSelector(
        (state) => state?.systemConfigData?.globalVariables?.date_format
    );

    const [dateFormat, setDateFormat] = useState('dd/mm/yyyy');

    // Update date format from sysconfig
    useEffect(() => {
        if (dateformatSysconfig) {
            const format = dateformatSysconfig.split(',')[0].toLowerCase();
            setDateFormat(format === 'mm/dd/yyyy' ? 'mm/dd/yyyy' : 'dd/mm/yyyy');
        }
    }, [dateformatSysconfig]);
    
    const handleDateChange = (newDate) => {
        setEmptyField(false);
        // Validate input: allow numbers and dashes, and apply limits
        // Allow any combination of numbers and dashes in each field, and apply limits only if no dash is present
        const validatedDay = /^[-0-9]*$/.test(newDate.day) && 
                (newDate.day.includes('-') || (newDate.day.length <= 2 && parseInt(newDate.day) <= 31)) 
            ? newDate.day 
            : '';
        
        const validatedMonth = /^[-0-9]*$/.test(newDate.month) && 
                (newDate.month.includes('-') || (newDate.month.length <= 2 && parseInt(newDate.month) <= 12)) 
            ? newDate.month 
            : '';
        
        const validatedYear = /^[-0-9]*$/.test(newDate.year) && 
                (newDate.year.includes('-') || newDate.year.length <= 4) 
            ? newDate.year 
            : '';
    
        // Check if the date is fully cleared
        const isDateCleared =
            (!validatedDay.trim() || validatedDay === '-') &&
            (!validatedMonth.trim() || validatedMonth === '-') &&
            (!validatedYear.trim() || validatedYear === '-');
    
        dispatch(setAlertNotificationSearch({
            ...AlertNotificationSearch,
            created_day: validatedDay,
            created_month: validatedMonth,
            created_year: validatedYear,
            // Uncheck the checkbox if the date fields are cleared
            created_date_inverse: isDateCleared ? '' : AlertNotificationSearch.created_date_inverse,
        }));
    };
    
    // Function to handle button click
    const handleCloseClick = () => {
    // Toggle the advanced search state
        setIsSearchOpen(!isSearchOpen)  
        // If previous sidebar state was true and isSideBar is currently false, set it to true
        if (sidebarPrvState === true && !isSideBar) {
            setIsSideBar(true);
        }
        // Reset search state if searchApplied is false
        if (!searchApplied) {            
            dispatch(resetAlertNotificationSearch());
        }
    };

    const isApplyButtonDisabled = () => {
        return Object.entries(AlertNotificationSearch).every(([key, value]) => {
            if (key === 'match') return true; // Ignore 'match'
            // Check if value is an array
            if (Array.isArray(value)) {
                return value.length === 0; // Return true if the array is empty
            }
            // Check if value is a string
            if (typeof value === 'string') {
                return value.trim() === ''; // Trim and check if it's empty
            }
            // For any other type (objects, numbers, etc.), return true to indicate it's 'empty'
            return true;
        });
    };

    /*** The `handleClearAll` function resets parameters and clears search-related fields.*/
    const handleClearAll = () => {
        dispatch(resetAlertNotificationSearch());
        const updatedParams = new URLSearchParams(searchParams);
        
        // Only delete if the parameters exist
        if (updatedParams.has('search')) {
            updatedParams.delete('search');
        }   
        if (updatedParams.has('search_mode')) {
            updatedParams.delete('search_mode');
        }
        setTimeout(()=>{
            setSearchParams(Object.fromEntries(updatedParams.entries()));
            setEmptyField(false);
        },300)
    };

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === "Escape") {
                handleClearAll();
            }
        };
        window.addEventListener("keydown", handleKeyDown);
        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [handleClearAll]);

    // useeffect to fetch from searchparams
    useEffect(() => {           
        const params = Object.fromEntries(searchParams);
    
        if (params.search) {
            const searchDecoded = decodeURIComponent(params.search);
    
            const updatedState = {};
    
            const matches = [
                { key: 'age', regex: /age=(ne:)?(.+?)(;|$)/ },
                { key: 'alert_title', regex: /alert_title=(ne:)?(.+?)(;|$)/ },
                { key: 'alert_message', regex: /alert_message=(ne:)?(.+?)(;|$)/ },
                { key: 'gender', regex: /gender=(ne:)?(.+?)(;|$)/ },
                { key: 'created_at', regex: /created_at=(ne:)?(\d+)(;|$)/ },
                { key: 'sender_user_id', regex: /sender_user_id=(ne:)?(.+?)(;|$)/ },
                { key: 'sender_full_name', regex: /sender_full_name=(ne:)?(.+?)(;|$)/ },
            ];
    
            matches.forEach(({ key, regex }) => {
                const match = searchDecoded.match(regex);
                if (match) {
                    const isInverse = !!match[1];
                    const value = match[2];
    
                    switch (key) {
                    case 'gender':
                    case 'age':
                        updatedState[key] = value === '__NULL__' ? '-' : value;
                        updatedState[`${key}_inverse`] = isInverse ? 'true' : '';
                        break;
                    case 'alert_title':
                    case 'alert_message':
                        updatedState[key] = value === '__NULL__' ? '-' : value;
                        updatedState[`${key}_inverse`] = isInverse ? 'true' : '';
                        break;
                    case 'created_at':
                        const epochTime = value;
                        const date = new Date(parseInt(epochTime, 10) * 1000);
                        updatedState.created_day = date.getDate().toString().padStart(2, '0');
                        updatedState.created_month = (date.getMonth() + 1).toString().padStart(2, '0');
                        updatedState.created_year = date.getFullYear().toString();
                        updatedState.created_date_inverse = isInverse ? 'true' : '';
                        break;
                    case 'sender_user_id':
                        updatedState.user_id = value === '__NULL__' ? '-' : value;
                        updatedState.user_id_inverse = isInverse ? 'true' : '';
                        break;
                    case 'sender_full_name':
                        updatedState.user_name = value === '__NULL__' ? '-' : value;
                        updatedState.user_name_inverse = isInverse ? 'true' : '';
                        break;
                    default:
                        break;
                    }
                }
            });
    
            const alertPriorityMatches = searchDecoded.match(/alert_priority=(ne:)?([^;]+)/g);
            if (alertPriorityMatches) {
                const alertPriorities = alertPriorityMatches.map((match) => {
                    const [, isInverse, priorityValue] = match.match(/alert_priority=(ne:)?(.+)/) || [];
                    return {
                        value: priorityValue === '__NULL__' ? '-' : decodeURIComponent(priorityValue),
                        isInverse: !!isInverse,
                    };
                });
    
                updatedState.alert_severity = alertPriorities.map((item) => item.value).join('; ');
                updatedState.alert_severity_inverse = alertPriorities.some((item) => item.isInverse) ? 'true' : '';
            }
    
            if (params.search_mode) {
                updatedState.match = params.search_mode === 'or';
            }
    
            dispatch(setAlertNotificationSearch(updatedState));
        }
    }, [isSearchOpen]);


    
    return (
        <div className='absolute top-0 left-0 w-[267px] rounded-tr-[12px] rounded-br-[12px] shadow-s7 h-[100dvh] bg-[#ffffff] z-[100]'>
            <form action='' 
                onSubmit={(e) => {handleOnSubmit(e);
                }} // Existing submit handler
                onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                        e.preventDefault(); 
                        handleOnSubmit(e);
                    }
                }}
                className='w-full px-3 py-4'>
                <section className='flex justify-between items-center'>
                    <p className='text-sm font-semibold text-[#52555D]'>Advanced Search</p>
                    <button type='button' onClick={handleCloseClick}>
                        <img src="/images/cross_mark_gray.svg" alt="close-icon" loading='lazy' decoding='async' />
                    </button>
                </section>
                <section className='mt-4 flex items-center pb-4 border-b border-[#C5C9DA]'>
                    <p className='text-xs font-normal text-[#000000] pr-2'>Match:</p>
                    <div className='flex items-center'>
                        <div className='flex items-center'>
                            <div className="relative custom-radioBlue flex items-center">
                                <input id="match_any" type="radio" name="default-radio1" checked={AlertNotificationSearch?.match} onChange={()=>handleOnChangeUserDetails("match",true)}/>
                                <label htmlFor="match_any" className={`text-xs font-normal ${AlertNotificationSearch?.match ? 'text-[#000000]' : 'text-[#52555D]'} pl-6 pr-2 w-full cursor-pointer`}>
                                    Any
                                </label>
                            </div>
                            <div className='relative'>
                                <span className='any_hover'>
                                    <img src="/images/Tooltip.svg" alt="icon" loading='lazy' decoding='async' className='w-[15px] h-[15px] mt-[1px]' />
                                </span>
                                <p className='bg-[#000000] bg-opacity-75 p-2 text-xs font-normal text-[#FFFFFF] transition-all absolute top-[25px] left-[0px] any_hover_text hidden rounded-lg w-[212px] z-[1]'>
                                    Displays results that match any of the input values. <br />
                                    Example: A OR B will return results that match either A, B, or both.
                                </p>
                            </div>
                        </div>
                        <div className='flex items-center ml-4'>
                            <div className="relative custom-radioBlue flex items-center ml-3" >
                                <input id="match_all"  type="radio" name="default-radio1" checked={!AlertNotificationSearch?.match} onChange={()=>handleOnChangeUserDetails("match",false)}/>
                                <label htmlFor="match_all" className={`text-xs font-normal ${!AlertNotificationSearch?.match ? 'text-[#000000]' : 'text-[#52555D]'} pl-6 pr-2 w-full cursor-pointer`}>
                                    All 
                                </label>
                            </div>
                            <div className='relative'>
                                <span className='any_hover'>
                                    <img src="/images/Tooltip.svg" alt="icon" loading='lazy' decoding='async' className='w-[15px] h-[15px] mt-[1px]' />
                                </span>
                                <p className='bg-[#000000] bg-opacity-75 p-2 text-xs font-normal text-[#FFFFFF] transition-all absolute top-[25px] left-[0px] any_hover_text hidden rounded-lg w-[212px] z-[1]'>
                                    Displays results that match all of the input values. <br />
                                    Example: A AND B will only return results that match both A and B.
                                </p>
                            </div>
                        </div>
                    </div>
                </section>
                {emptyField && 
                    <p className='text-xs font-normal text-[#c52828] my-1 text-center'>Please fill the date field completely</p>
                }
                <div className='w-full flex items-center my-3'>
                    <div className='w-[170px] mr-2'>
                        <p className='text-xs font-normal text-[#52555D]'>Column Name & Value</p>
                    </div>
                    <div className='relative w-[65px] flex items-center'>
                        <p className='text-xs font-normal text-[#52555D]'>Inverse</p>
                        <span className='any_hover z-[99] ml-1'>
                            <img src="/images/Tooltip.svg" alt="icon" loading='lazy' decoding='async' className='w-[15px] h-[15px]' />
                        </span>
                        <p className='bg-[#000000] bg-opacity-75 p-2 text-xs font-normal text-[#FFFFFF] transition-all absolute top-[25px] left-[0px] any_hover_text hidden rounded-lg w-[212px] z-[10]'>
                            Excludes results that match the input value. <br />
                            Example: NOT A will return all results except those that match A.
                        </p>
                    </div>
                </div>
                <div className='-ml-2'>
                    <div className={`overflow-auto ${emptyField?'h-[calc(100dvh-302px)]':'h-[calc(100dvh-285px)]'} scrollbar_purple pl-2`}>
                        
                        <div className='w-full flex border-b border-[#C5C9DA66] pb-2 pt-1'>
                            <div className='w-[170px] mr-2'>
                                <DateInput
                                    labeltext={`Timestamp`}
                                    date={{
                                        day: AlertNotificationSearch.created_day,
                                        month: AlertNotificationSearch.created_month,
                                        year: AlertNotificationSearch.created_year,
                                    }}
                                    onDateChange={handleDateChange}
                                    dateFormat={dateFormat}
                                    idPrefix="created"
                                />
                            </div>
                            <div className='relative w-[65px] mt-[20px]'>
                                <div className='p-[8px] flex items-center mark-check mark-check1 mark-check2 relative checkbox custom-checkBoxBlue1'>
                                    <input
                                        type='checkbox'
                                        id='created_date_inverse'
                                        onChange={(e) => handleCheckboxChange(e, 'created_date_inverse')}
                                        checked={AlertNotificationSearch.created_date_inverse === 'true'}
                                        className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                        disabled={AlertNotificationSearch?.created_day?.trim()==="" || AlertNotificationSearch?.created_month?.trim()==="" || AlertNotificationSearch?.created_year?.trim()===""}
                                    />
                                    <label htmlFor='created_date_inverse' className='text-[16px] font-normal text-[#000] ml-[16px] cursor-pointer'>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className='w-full flex border-b border-[#C5C9DA66] pb-2 pt-1'>
                            <div className='w-[170px] mr-2'>
                                <AdvancedSearchInputBox
                                    label={"Age"}
                                    placeholder={"Enter age"}
                                    id={"age"}
                                    data_testid={"age"}
                                    htmlFor={"age"}
                                    value={AlertNotificationSearch?.age}
                                    handleOnChangeInput={handleOnChangeUserDetails}
                                    maxLength={3}
                                />
                            </div>
                            <div className='relative w-[65px] mt-[20px]'>
                                <div className='p-[8px] flex items-center mark-check mark-check1 mark-check2 relative checkbox custom-checkBoxBlue1'>
                                    <input
                                        type='checkbox'
                                        id='age_inverse'
                                        onChange={(e) => handleCheckboxChange(e, 'age_inverse')}
                                        checked={AlertNotificationSearch?.age_inverse === 'true'}
                                        className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                        disabled={AlertNotificationSearch?.age?.trim()===""}
                                    />
                                    <label htmlFor='age_inverse' className='text-[16px] font-normal text-[#000] ml-[16px] cursor-pointer'>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className='w-full flex border-b border-[#C5C9DA66] pb-2 pt-1'>
                            <div className='w-[170px] mr-2'>
                                <Dropdown
                                    label={"Gender"}
                                    id={"gender"}
                                    placeholder={AlertNotificationSearch?.gender?.length > 0 ? '' : 'Select gender'}
                                    data_testid={"gender"}
                                    value={AlertNotificationSearch?.gender}
                                    options={['Male','Female','Other']}
                                    handleOnChangeInput={handleOnChangeUserDetails}   
                                    searchDropdown={true}  
                                />     
                            </div>
                            <div className='relative w-[65px] mt-[20px]'>
                                <div className='p-[8px] flex items-center mark-check mark-check1 mark-check2 relative checkbox custom-checkBoxBlue1'>
                                    <input
                                        type='checkbox'
                                        id='gender_inverse'
                                        onChange={(e) => handleCheckboxChange(e, 'gender_inverse')}
                                        checked={AlertNotificationSearch?.gender_inverse === 'true'}
                                        className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                        disabled={AlertNotificationSearch?.gender.trim()===''}
                                    />
                                    <label htmlFor='gender_inverse' className='text-[16px] font-normal text-[#000] ml-[16px] cursor-pointer'>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className='w-full flex border-b border-[#C5C9DA66] pb-2 pt-1'>
                            <div className='w-[170px] mr-2'>
                                <p className='text-xs font-normal text-[#000000] mb-1 more-lines'>Alert Priority</p>
                                <div className='flex items-center'>
                                    <div className='py-[8px] pr-[20px] pl-[8px] flex items-center checkboxFocusAllignment mark-check mark-check1 mark-check2 relative checkbox custom-checkBoxBlue1'>
                                        <input
                                            type='checkbox'
                                            id='High'
                                            onChange={(e) => handleCheckboxChange(e, 'High')}
                                            checked={AlertNotificationSearch?.alert_severity?.includes('High')}
                                            className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                        />
                                        <label htmlFor='High' className='text-xs font-normal text-[#000] cursor-pointer'>
                                            High
                                        </label>
                                    </div>
                                    <div className='p-[8px] flex items-center mark-check mark-check1 mark-check2 relative checkbox custom-checkBoxBlue1'>
                                        <input
                                            type='checkbox'
                                            id='Medium'
                                            onChange={(e) => handleCheckboxChange(e, 'Medium')}
                                            checked={AlertNotificationSearch?.alert_severity?.includes('Medium')}
                                            className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                        />
                                        <label htmlFor='Medium' className='text-xs font-normal text-[#000] cursor-pointer'>
                                            Medium
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div className='relative w-[65px] mt-[20px]'>
                                <div className='p-[8px] flex items-center mark-check mark-check1 mark-check2 relative checkbox custom-checkBoxBlue1'>
                                    <input
                                        type='checkbox'
                                        id='alert_severity_inverse'
                                        onChange={(e) => handleCheckboxChange(e, 'alert_severity_inverse')}
                                        checked={AlertNotificationSearch?.alert_severity_inverse === 'true'}
                                        className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                        disabled={AlertNotificationSearch?.alert_severity?.length === 0}
                                    />
                                    <label htmlFor='alert_severity_inverse' className='text-[16px] font-normal text-[#000] ml-[16px] cursor-pointer'>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className='w-full flex border-b border-[#C5C9DA66] pb-2 pt-1'>
                            <div className='w-[170px] mr-2'>
                                <AdvancedSearchInputBox
                                    label={"Alert Title"}
                                    placeholder={"Enter alert title"}
                                    id={"alert_title"}
                                    data_testid={"alert_title"}
                                    htmlFor={"alert_title"}
                                    value={AlertNotificationSearch?.alert_title}
                                    handleOnChangeInput={handleOnChangeUserDetails}
                                    maxLength={16}
                                />
                            </div>
                            <div className='relative w-[65px] mt-[20px]'>
                                <div className='p-[8px] flex items-center mark-check mark-check1 mark-check2 relative checkbox custom-checkBoxBlue1'>
                                    <input
                                        type='checkbox'
                                        id='alert_title_inverse'
                                        onChange={(e) => handleCheckboxChange(e, 'alert_title_inverse')}
                                        checked={AlertNotificationSearch?.alert_title_inverse === 'true'}
                                        className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                        disabled={AlertNotificationSearch?.alert_title?.trim()===""}
                                    />
                                    <label htmlFor='alert_title_inverse' className='text-[16px] font-normal text-[#000] ml-[16px] cursor-pointer'>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className='w-full flex border-b border-[#C5C9DA66] pb-2 pt-1'>
                            <div className='w-[170px] mr-2'>
                                <AdvancedSearchInputBox
                                    label={"Alert Message"}
                                    placeholder={"Enter alert message"}
                                    id={"alert_message"}
                                    data_testid={"alert_message"}
                                    htmlFor={"alert_message"}
                                    value={AlertNotificationSearch?.alert_message}
                                    handleOnChangeInput={handleOnChangeUserDetails}
                                />
                            </div>
                            <div className='relative w-[65px] mt-[20px]'>
                                <div className='p-[8px] flex items-center mark-check mark-check1 mark-check2 relative checkbox custom-checkBoxBlue1'>
                                    <input
                                        type='checkbox'
                                        id='alert_message_inverse'
                                        onChange={(e) => handleCheckboxChange(e, 'alert_message_inverse')}
                                        checked={AlertNotificationSearch?.alert_message_inverse === 'true'}
                                        className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                        disabled={AlertNotificationSearch?.alert_message?.trim()===""}
                                    />
                                    <label htmlFor='alert_message_inverse' className='text-[16px] font-normal text-[#000] ml-[16px] cursor-pointer'>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className='w-full flex border-b border-[#C5C9DA66] pb-2 pt-1'>
                            <div className='w-[170px] mr-2'>
                                <AdvancedSearchInputBox
                                    label={`User ID`}
                                    placeholder={`Enter user ID`}
                                    id={"user_id"}
                                    data_testid={"user_id"}
                                    htmlFor={"user_id"}
                                    value={AlertNotificationSearch?.user_id}
                                    handleOnChangeInput={handleOnChangeUserDetails}
                                    maxLength={60}
                                />
                            </div>
                            <div className='relative w-[65px] mt-[20px]'>
                                <div className='p-[8px] flex items-center mark-check mark-check1 mark-check2 relative checkbox custom-checkBoxBlue1'>
                                    <input
                                        type='checkbox'
                                        id='user_id_inverse'
                                        onChange={(e) => handleCheckboxChange(e, 'user_id_inverse')}
                                        checked={AlertNotificationSearch?.user_id_inverse === 'true'}
                                        className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                        disabled={AlertNotificationSearch?.user_id?.trim()===""}
                                    />
                                    <label htmlFor='user_id_inverse' className='text-[16px] font-normal text-[#000] ml-[16px] cursor-pointer'>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className='w-full flex border-b border-[#C5C9DA66] pb-2 pt-1'>
                            <div className='w-[170px] mr-2'>
                                <AdvancedSearchInputBox
                                    label={`User Name`}
                                    placeholder={`Enter user name`}
                                    id={"user_name"}
                                    data_testid={"user_name"}
                                    htmlFor={"user_name"}
                                    value={AlertNotificationSearch?.user_name}
                                    handleOnChangeInput={handleOnChangeUserDetails}
                                    maxLength={60}
                                />
                            </div>
                            <div className='relative w-[65px] mt-[20px]'>
                                <div className='p-[8px] flex items-center mark-check mark-check1 mark-check2 relative checkbox custom-checkBoxBlue1'>
                                    <input
                                        type='checkbox'
                                        id='user_name_inverse'
                                        onChange={(e) => handleCheckboxChange(e, 'user_name_inverse')}
                                        checked={AlertNotificationSearch?.user_name_inverse === 'true'}
                                        className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                        disabled={AlertNotificationSearch?.user_name?.trim()===""}
                                    />
                                    <label htmlFor='user_name_inverse' className='text-[16px] font-normal text-[#000] ml-[16px] cursor-pointer'>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='border-t border-[#C5C9DA]'>
                    <section className='mt-2'>
                        <p className='text-xs font-normal text-[#52555D]'>Note:</p>
                        <ol className='list-decimal pl-4 text-xs font-normal text-[#52555D]'>
                            <li>Use a dash (-) to indicate a null value.</li>
                            <li>Use an asterisk (*) as a wild-card character.</li>
                        </ol>
                    </section>
                </div>
                <div className="flex mt-[13px] justify-between">
                    <button 
                        id="Cancel"
                        type='button'
                        onClick={() => handleClearAll()}
                        onKeyDown={(e) => {
                            if (e.key === "Enter") {
                                e.preventDefault(); // Prevent form submission
                                handleClearAll(); // Perform the clear action
                            }
                        }}

                        className="py-2.5 px-4 rounded-[16px] border border-[#972E4C] text-sm font-semibold text-[#972E4C] min-w-fit focus:bg-[#edc9d3]" 
                    >Clear All</button>
                    <button  
                        type='submit'
                        id="apply-filter"
                        disabled={isApplyButtonDisabled()}
                        className={`py-2.5 w-[106px] px-4 rounded-[16px]  disabled:bg-[#777C88] bg-[#972E4C] hover:bg-[#AB556E] border border-[#972E4C]'} text-sm font-semibold text-[#FFFFFF] hover:duration-75 reset_password_conf`}>
                        Apply
                    </button>
                </div>
            </form>
        </div>
    )
}
